import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-countdown', 'days', 'Дни');
Labels.set('ui-countdown', 'hours', 'Часы');
Labels.set('ui-countdown', 'minutes', 'Минуты');
Labels.set('ui-countdown', 'seconds', 'Секунды');
